import Input from 'components/form/Input'
import { RadioGroup, RadioItem } from 'components/form/RadioGroup'
import { genderType } from 'constants/commons'

const AddOperatorForm = ({ operator, handleOperatorChange }) => {
  return (
    <div className="relative">
      <div>
        <Input
          type="text"
          color="blue"
          placeholder="First Name"
          value={operator.first_name}
          onChange={(e) => {
            handleOperatorChange('first_name', e.target.value)
          }}
        />
        <Input
          type="text"
          color="blue"
          placeholder="Last Name"
          value={operator.last_name}
          onChange={(e) => {
            handleOperatorChange('last_name', e.target.value)
          }}
        />
        <Input
          type="text"
          color="blue"
          placeholder="Mobile"
          value={operator.mobile}
          onChange={(e) => {
            handleOperatorChange('mobile', e.target.value)
          }}
        />
      </div>
      <div className="w-full mb-4">
        <div className="flex space-x-5">
          <RadioGroup label="Gender">
            {genderType.map((gender) => {
              return (
                <RadioItem
                  key={gender.label}
                  name="gender"
                  label={gender.label}
                  value={operator.gender}
                  isChecked={operator.gender === gender.value}
                  onChanged={() => {
                    handleOperatorChange('gender', gender.value)
                  }}
                />
              )
            })}
          </RadioGroup>
        </div>
      </div>
    </div>
  )
}

export default AddOperatorForm
